import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="mx-auto grid min-h-[60vh] max-w-lg place-items-center px-5 text-center">
      <div className="fade-up">
        <span className="mx-auto grid h-16 w-16 place-items-center rounded-xl st-pending">
          <XCircle className="h-9 w-9 text-[#ecc98a]" />
        </span>
        <h1 className="font-display mt-6 text-3xl font-medium tracking-tight text-ppc-text">
          {t("pay_cancel_t")}
        </h1>
        <p className="mt-3 text-ppc-muted">{t("pay_cancel_d")}</p>
        <Button
          onClick={() => navigate("/dashboard")}
          data-testid="pay-cancel-dashboard-btn"
          className="mt-8 rounded-xl btn-primary px-6"
        >
          {t("back_dashboard")}
        </Button>
      </div>
    </div>
  );
}
